<template>
  <div class="absolute top-20 w-full md:top-0 right-0 max-[767px]:relative">
    <!-- Placeholder: same aspect ratio to avoid layout shift, visible until image loads -->
    <div
      class="absolute right-0 w-full md:w-[50%] min-h-[200px] md:min-h-0 aspect-[1133/915] transition-opacity duration-300"
      aria-hidden="true"
    />
    <!-- Keep plain img + srcset (not NuxtImg): responsive WebP avoids IPX and saves ~26 KiB / better LCP. -->
    <img
      src="/home/gfs-group-tradelines-for-sale.webp"
      srcset="
        /home/gfs-group-tradelines-for-sale-320w.webp 320w,
        /home/gfs-group-tradelines-for-sale-400w.webp 400w,
        /home/gfs-group-tradelines-for-sale-568w.webp 568w,
        /home/gfs-group-tradelines-for-sale-800w.webp 800w,
        /home/gfs-group-tradelines-for-sale.webp 1133w
      "
      sizes="(max-width: 767px) 100vw, (max-width: 1280px) 50vw, 568px"
      width="1133"
      height="915"
      class="flex absolute right-0 w-full md:w-[50%] transition-opacity duration-300"
      :alt="t('landing_home_rocket_bg.alt')"
      loading="eager"
      fetchpriority="high"
      decoding="async"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>
